import { render } from "./BetDetail.vue?vue&type=template&id=70374a7d&scoped=true"
import script from "./BetDetail.vue?vue&type=script&lang=js"
export * from "./BetDetail.vue?vue&type=script&lang=js"

import "./BetDetail.vue?vue&type=style&index=0&id=70374a7d&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70374a7d"]])

export default __exports__